import Client from './client';

export default class ShopifyMarketsSyncs extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  postCatalogs(organization, options = {}) {
    return this.makeRequest(`${this.host}/internal/${organization}/shopify/markets/sync/catalogs`, {
      ...options,
       method: 'POST',
    });
  }

}
